<template>
	<div>
		<v-expansion-panels v-if="access && access.length > 0">
			<v-expansion-panel v-for="(item, i) in access" :key="i">
				<v-expansion-panel-header>{{ item.name }}</v-expansion-panel-header>
				<v-expansion-panel-content>
					<v-list v-if="item.types && item.types.length > 0">
						<div v-for="(type, t) in item.types" :key="t">
							<v-list-item>
								<v-list-item-action v-if="type.key != 'Schedules'">
									<v-checkbox
										v-model="type.value"
										@mouseup="inputCheckbox"
									></v-checkbox>
								</v-list-item-action>

								<v-list-item-action v-else>
									<!-- <v-checkbox
										v-model="type.value"
										@mouseup="inputCheckbox"
									></v-checkbox> -->
									<div v-for="(day, d) in item.schedules" :key="d">
										<v-list-item-title style="margin-left:20px; padding:10px;"
											>{{ day.day }}

											<div style="padding:20px">
												<input
													type="time"
													id="appt_start"
													:value="day.startTime"
													@change="setStartTime(day, $event)"
													name="appt_start"
													min="09:00"
													max="18:00"
													required
												/>

												<input
													type="time"
													:value="day.endTime"
													@change="setEndTime(day, $event)"
													id="appt_end"
													name="appt_end"
													min="09:00"
													max="18:00"
													required
												/>
											</div>
										</v-list-item-title>
									</div>
								</v-list-item-action>
								<v-list-item-title v-if="type.key != 'Schedules'">{{
									type.key
								}}</v-list-item-title>
							</v-list-item>
						</div>
					</v-list>
				</v-expansion-panel-content>
			</v-expansion-panel>
		</v-expansion-panels>
	</div>
</template>

<script>
	export default {
		props: { value: {} },
		data() {
			return {
				access: [],
			};
		},
		watch: {
			async value() {
				await this.getAccess(this.value.id);
			},
		},
		methods: {
			setStartTime: function(item, event) {
				item.startTime = event.target.value; // Actual assignment
				this.$emit("change", {
					userId: this.value.id,
					accessManager: this.access,
				});
			},
			setEndTime: function(item, event) {
				item.endTime = event.target.value; // Actual assignment
				this.$emit("change", {
					userId: this.value.id,
					accessManager: this.access,
				});

				//console.log(this.access);
			},
			inputCheckbox() {
				this.$emit("change", {
					userId: this.value.id,
					accessManager: this.access,
				});

				console.log(this.accessManager);
			},
			async getAccess(userId) {
				if (!this.value.id) return;
				let res = await this.$http.get(`user/access-manager?userId=${userId}`);
				console.log("accessos", res);
				if (res.success) this.access = res.data;
			},
		},
		async mounted() {
			await this.getAccess(this.value.id);
		},
	};
</script>
